import gql from 'graphql-tag';

import {
    address,
    clientOffice,
    clientVoucher,
    lectureInstance,
    lectureTerm,
    officeEmployee,
    officePlace,
    organisationUser,
    user,
    userConfig,
    userEmployee,
    userOfficeClient,
    userOrder,
    userOrganisationClient,
    userReservations,
} from '../fragments';

export const getUserByEmail = gql`
    query GetUserByEmail($email: String!) {
        publicUserByEmail(email: $email) {
            id
            userId
            name
            registrationStatus
            systemStatus
        }
    }
`;

export const getUserById = gql`
    query GetUserById($userId: Int!) {
        userById(userId: $userId) {
            ...UserFragment
            userConfig {
                ...ConfigFragment
            }
        }
    }
    ${user}
    ${userConfig}
`;

export const getUserOrders = gql`
    query GetUserOrders($userId: Int!, $limit: Int!, $offset: Int) {
        userOrders(userId: $userId, limit: $limit, offset: $offset) {
            orders {
                ...UserOrderFragment
                lectureTermInstance {
                    ...LectureTermFragment
                    lectureInstance {
                        ...LectureInstanceFragment
                    }
                }
            }
            totalCount
        }
    }
    ${userOrder}
    ${lectureTerm}
    ${lectureInstance}
`;

export const getUserOrderById = gql`
    query GetUserOrderById($userId: Int!, $clientOrderId: String!) {
        userOrderById(userId: $userId, clientOrderId: $clientOrderId) {
            ...UserOrderFragment
            lectureTermInstance {
                ...LectureTermFragment
                lectureInstance {
                    ...LectureInstanceFragment
                }
            }
        }
    }
    ${userOrder}
    ${lectureTerm}
    ${lectureInstance}
`;

export const getOrganisationSingleUser = gql`
    query OrganisationSingleUser($organisationUserId: Int!) {
        organisationSingleUser(organisationUserId: $organisationUserId) {
            ...OrganisationUserFragment
        }
    }
    ${organisationUser}
`;

export const getClientByUserIdAndOfficeId = gql`
    query GetClientByUserIdAndOfficeId($officeId: Int!, $userId: Int!) {
        clientByUserIdAndOfficeId(officeId: $officeId, userId: $userId) {
            ...UserClientFragment
        }
    }
    ${userOfficeClient}
`;

export const getUserVouchers = gql`
    query GetUserVouchers($userId: Int!, $input: UserVouchersInput) {
        getUserVouchers(userId: $userId, input: $input) {
            claimed {
                ...ClientVoucherFragment
            }
            bought {
                ...ClientVoucherFragment
            }
        }
    }
    ${clientVoucher}
`;

export const getReservationsByUserId = gql`
    query GetReservationsByUserId($userId: Int!, $filters: ReservationsByUserIdFiltersInput) {
        reservationsByUserId(userId: $userId, filters: $filters) {
            ...UserReservationFragment
            lectureTermInstance {
                ...LectureTermFragment
                lectureInstance {
                    ...LectureInstanceFragment
                }
            }
        }
    }
    ${userReservations}
    ${lectureTerm}
    ${lectureInstance}
`;

export const getReservationsByClientId = gql`
    query GetReservationsByClientId($officeId: Int!, $clientId: Int!, $limit: Int!, $offset: Int) {
        reservationsByClientId(officeId: $officeId, clientId: $clientId, limit: $limit, offset: $offset) {
            reservations {
                ...UserReservationFragment
                lectureTermInstance {
                    ...LectureTermFragment
                    lectureInstance {
                        ...LectureInstanceFragment
                    }
                }
            }
            totalCount
        }
    }
    ${userReservations}
    ${lectureTerm}
    ${lectureInstance}
`;

export const getReservationByReservationToken = gql`
    query GetReservationByReservationToken(
        $reservationToken: String!
        $filters: LectureTermReservationByTokenFiltersInput
    ) {
        reservationByReservationToken(reservationToken: $reservationToken, filters: $filters) {
            ...UserReservationFragment
            lectureTermInstance {
                ...LectureTermFragment
                lectureInstance {
                    ...LectureInstanceFragment
                    place {
                        ...OfficePlaceFragment
                        address {
                            ...AddressFragment
                        }
                    }
                    lecturer {
                        ...OfficeEmployeeFragment
                    }
                }
            }
        }
    }
    ${userReservations}
    ${lectureTerm}
    ${lectureInstance}
    ${officePlace}
    ${address}
    ${officeEmployee}
`;

export const getClientmentsByUserId = gql`
    query GetClientmentsByUserId($userId: Int!) {
        clientmentsByUserId(userId: $userId) {
            ...OrganisationClientFragment
        }
    }
    ${userOrganisationClient}
`;

export const getClientOfficeByUserIdAndOfficeId = gql`
    query GetClientOfficeByUserIdAndOfficeId($userId: Int!, $officeId: Int!) {
        clientOfficeByUserIdAndOfficeId(userId: $userId, officeId: $officeId) {
            ...ClientOfficeFragment
        }
    }
    ${clientOffice}
`;

export const getClientOfficeByUserIdAndOfficeIdRequestedByEmployee = gql`
    query GetClientOfficeByUserIdAndOfficeIdRequestedByEmployee($userId: Int!, $officeId: Int!) {
        clientOfficeByUserIdAndOfficeIdRequestedByEmployee(userId: $userId, officeId: $officeId) {
            ...ClientOfficeFragment
        }
    }
    ${clientOffice}
`;

export const getEmploymentsByUserId = gql`
    query GetEmploymentsByUserId($userId: Int!) {
        employmentsByUserId(userId: $userId) {
            ...EmployeeFragment
        }
    }
    ${userEmployee}
`;

export const getOfficeEmploymentsByUserIdForDropdown = gql`
    query GetOfficeEmploymentsByUserIdForDropdown($userId: Int!) {
        officeEmploymentsByUserIdForDropdown(userId: $userId) {
            organisationOffices {
                officeId
                name
                domain
                role
            }
        }
    }
`;

export const getEmploymentByUserIdAndOfficeId = gql`
    query GetEmploymentByUserIdAndOfficeId($userId: Int!, $officeId: Int!) {
        employmentByUserIdAndOfficeId(userId: $userId, officeId: $officeId) {
            ...EmployeeFragment
        }
    }
    ${userEmployee}
`;

export const getEmploymentByUserIdAndOfficeDomain = gql`
    query GetEmploymentByUserIdAndOfficeDomain($userId: Int!, $domain: String!) {
        employmentByUserIdAndOfficeDomain(userId: $userId, domain: $domain) {
            ...EmployeeFragment
        }
    }
    ${userEmployee}
`;

export const getClientOffice = gql`
    query ClientOffice($clientId: Int!, $officeId: Int!) {
        clientOffice(clientId: $clientId, officeId: $officeId) {
            ...ClientOfficeFragment
        }
    }
    ${clientOffice}
`;
